var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_BASE_URL, getHeadersForFrontendCall, readStream } from './helpers';
import { isFrontend, isSoql, isOmni, isStoryteller } from '../types';
const isRunningLocally = API_BASE_URL === 'http://localhost:3456';
export const getQuery = (_a, proxyApp_1, appContext_1, mode_1) => __awaiter(void 0, [_a, proxyApp_1, appContext_1, mode_1], void 0, function* ({ onData, conversation }, proxyApp, appContext, mode) {
    let url = API_BASE_URL + '/v1/chat';
    let headers = { 'Content-type': 'application/json' };
    if (!isRunningLocally) {
        headers = getHeadersForFrontendCall();
        if (isFrontend(proxyApp)) {
            url = '/data_assistant/chat_query.json';
        }
        else if (isStoryteller(proxyApp)) {
            url = '/stories/api/v1/chatbot/chat_query.json';
        }
    }
    if (isSoql(mode) || isOmni(mode)) {
        delete appContext.commonQuestions;
    }
    try {
        const response = yield fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                messages: conversation,
                context: appContext,
            }),
            credentials: 'include',
        });
        if (!response.ok)
            throw new Error(yield response.text());
        const responseBody = response.body;
        if (responseBody) {
            yield readStream(responseBody, onData);
        }
        else {
            throw new Error('Response body is null');
        }
    }
    catch (error) {
        console.error('Error sending message to Data Assistant: ', error);
        throw error;
    }
});
//# sourceMappingURL=query.js.map